const csvTemplate = `account_group,promotion_name,start_period,end_period,reference
GUARDIAN,PROMO GUARDIAN JUNE,1-Jun-26,30-Jun-26,REF0010020022
GT 1,GT1 PROMO MAY,1-May-26,31-May-26,SY.MU-FUBBC301`;

export default csvTemplate;
